import { useNotificationsState } from "../../NotificationsContext";
import useNotificationReadAllMutation from "../../hooks/useNotificationReadAllMutation";
import { NotificationList } from "./NotificationList";

export type Props = {
  isRefetching: boolean;
};

export function NotificationListContainer({ isRefetching }: Props) {
  const { notifications, hasMore, unreadCount } = useNotificationsState();

  const { mutate: markAllAsRead } = useNotificationReadAllMutation();

  return (
    <NotificationList
      notifications={notifications}
      hasMore={hasMore}
      unreadCount={unreadCount}
      isRefetching={isRefetching}
      onMarkAllAsRead={markAllAsRead}
    />
  );
}

export default NotificationListContainer;
